import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getQualificationScore, QUALIFICATION_SCORE_THRESHOLD_PERCENTAGES } from '../../evaluationEntries';
import Chart from './chart';
import Stats, { filterFullyDecided } from './stats';

const ChartView = ({ submissions, session, predecessorSessionSubmissions }) => {
  const { t } = useTranslation();
  const initialThreshold = useMemo(() => {
    if (!session?.sessionType || !submissions?.length) return null;

    return getQualificationScore(
      filterFullyDecided(submissions, session?.sessionType).sort(
        (a, b) => a.finalPoints - b.finalPoints
      ),
      QUALIFICATION_SCORE_THRESHOLD_PERCENTAGES[session?.sessionType],
      t
    );
  }, [submissions, session]);

  const preselectionThreshold = useMemo(() => {
    if (!predecessorSessionSubmissions?.length || !session?.sessionType)
      return null;

    return getQualificationScore(
      predecessorSessionSubmissions.sort(
        (a, b) => a.finalPoints - b.finalPoints
      ),
      100 / 3,
      t
    );
  }, [predecessorSessionSubmissions, session]);

  return (
    <div>
      <Stats
        submissions={submissions}
        session={session}
        predecessorSessionSubmissions={predecessorSessionSubmissions}
      />
      <Chart
        submissions={submissions}
        session={session}
        preselectionThreshold={preselectionThreshold}
        initialThreshold={initialThreshold}
      />
    </div>
  );
};

export default ChartView;
